import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsBoost from 'highcharts/modules/boost';
import chartConfig from '../../helper/chartConfig';
import HighchartsDark from '../../themes/HighchartsDark';
import { GROUPING_MODE_GROUP } from '../../constants/actionTypes';
import { CHART_MIN_TICK_INTERVAL } from '../../constants/charts';

HighchartsBoost(Highcharts);

const selectByDrag = (event, updateQueryParams, fetchOnSelect) => {
  if (!fetchOnSelect) {
    return;
  }

  if (event.xAxis.length === 0) {
    return;
  }
  const { max, min } = event.xAxis[0];

  updateQueryParams({
    from: Math.round(min / 1000),
    to: Math.round(max / 1000)
  });
};

class Chart extends Component {
  initializeChart = props => {
    const localOptions = Object.assign({}, chartConfig);
    const {
      timeSeries,
      utcOffset,
      chartOptions,
      updateQueryParams,
      external
    } = props;

    Highcharts.setOptions({
      global: {
        useUTC: true
      }
    });

    localOptions.plotOptions.series.connectNulls = chartOptions.connectNulls;
    localOptions.chart.type = chartOptions.chartType;
    localOptions.chart.events.selection = event =>
      selectByDrag(event, updateQueryParams, chartOptions.fetchOnSelect);

    const yAxisMax = timeSeries.max.power;

    localOptions.yAxis[0].minTickInterval = CHART_MIN_TICK_INTERVAL;

    if (timeSeries.multi && timeSeries.mode !== GROUPING_MODE_GROUP) {
      localOptions.yAxis = [];
      localOptions.chart.alignTicks = false;

      for (let [key, energyType] of Object.entries(chartOptions.energyTypes)) {
        if (chartOptions.activeEnergyTypes.includes(key) === false) {
          continue;
        }

        /* if (energyType.hasOwnProperty('alignTicks')) {
          console.log(key, energyType.yAxisMax);
          // localOptions.chart.alignTicks = energyType.alignTicks;
        } */

        const max = energyType.hasOwnProperty('yAxisMax')
          ? energyType.yAxisMax
          : yAxisMax;

        const yAxisRight = energyType.hasOwnProperty('opposite')
          ? energyType.opposite
          : false;

        localOptions.yAxis.push({
          title: { text: energyType.unit },
          opposite: yAxisRight,
          max,
          minTickInterval: CHART_MIN_TICK_INTERVAL
        });
      }
    }

    // add samples
    if (
      timeSeries.dataGroup &&
      Object.keys(timeSeries.dataGroup).length > 0 &&
      !timeSeries.sumMode
    ) {
      localOptions.series = Object.keys(
        timeSeries.dataGroup
      ).map((key, index) => {
        const data = timeSeries.dataGroup[key];
        return {
          lineWidth: timeSeries.options.lineWidth,
          name: timeSeries.names[index],
          data: data[0]
        };
      });
    } else {
      localOptions.series = timeSeries.data.map((data, index) => ({
        lineWidth: timeSeries.options.lineWidth,
        yAxis: index,
        name: timeSeries.names[index],
        data
      }));
    }

    if (external) {
      Highcharts.theme = HighchartsDark;
      Highcharts.setOptions(Highcharts.theme);
    }

    Highcharts.setOptions({ global: { timezoneOffset: -utcOffset } });
    this.chart = new Highcharts['Chart'](this.chartEl, { ...localOptions });
  };

  updateChart = nextProps => {
    const { chartOptions: { connectNulls } } = nextProps;
    const connectNullsChanged = connectNulls !== this.props.connectNulls;
    // const timeSeriesChanged = JSON.stringify(timeSeries) !== this.props.timeSeries;

    if (connectNullsChanged) {
      this.chart.update({
        plotOptions: {
          series: {
            connectNulls: connectNulls
          }
        }
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.initializeChart(nextProps);
  }

  componentDidMount() {
    this.initializeChart(this.props);
  }

  componentWillUpdate(nextProps) {
    return (
      JSON.stringify(nextProps.queryParams) ===
      JSON.stringify(this.props.queryParams)
    );
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    return <div style={{ height: 220 }} ref={el => (this.chartEl = el)} />;
  }
}

export default Chart;



// WEBPACK FOOTER //
// ./src/components/charts/Chart.js